<template>
  <div :class="_.copy" @click="handleClick">
    <slot>复制</slot>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { copyTextToClipboard } from 'vtils'
  import { Toast } from 'vant'

  export default Vue.extend({
    props: {
      text: {
        type: String,
        required: true,
      },
    },

    methods: {
      handleClick() {
        copyTextToClipboard(this.text)
        Toast.success('复制成功')
      },
    },
  })
</script>

<style lang="scss" module>
  .copy {
    margin-left: 12px;
    width: 32px;
    height: 16px;
    background: #fff3f2;
    border-radius: 8px;
    font-size: 11px;
    color: #ff202a;
    display: flex;
    align-items: center;
    justify-content: center;

    &:active {
      opacity: 0.8;
    }
  }
</style>
